/**
 * The brief's day, written out in the reader's language.
 *
 * The server sends the site's civil day (`YYYY-MM-DD`), which is read in UTC
 * on purpose: a calendar day has no zone, and parsing it in the browser's
 * would shift it by one for any reader west of the site.
 */
export function formatBriefDate(date: string, locale: string): string {
  const day = new Date(`${date}T00:00:00Z`);
  if (Number.isNaN(day.getTime())) return date;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'full', timeZone: 'UTC' }).format(day);
}
